<template>
    <main class="main">
        <div class="container">
            <section-header
                title="Komunikaty"
                sub-title="
                    Sekcja komunikatów służy do przekazywania użytkownikom EuroPlatform
                    najważniejszych informacji. Odwiedzaj ją regularnie, a będziesz na bieżąco!
                "
                class="mb-2 mb-md-5"
            />
            <div class="row">
                <div class="col-md-3">
                    <the-filters
                        @applyFilters="onFiltersApply"
                        :filters="filters"
                        :moduleName="'news'"
                    />
                </div>
                <div class="col-md-9">
                    <div
                        class="c-settings pt-0 mb-3 d-flex justify-content-end"
                        v-if="news && news.length"
                    >
                        <button
                            class="btn btn-outline-custom"
                            @click="$store.dispatch('markAllNewsAsRead')"
                        >
                            <span>Oznacz wszystkie jako przeczytane</span>
                        </button>
                    </div>
                    <page-preloader
                        v-if="newsStatus === 'loading'"
                    ></page-preloader>
                    <div v-else class="richTable-body">
                        <template v-if="news && news.length">
                            <notification-preview
                                v-for="(item, idx) in news"
                                :key="idx"
                                class="richTable-row message"
                                :data="item"
                                :idx="idx"
                            />
                        </template>
                        <template v-else> Brak powiadomień </template>
                    </div>
                    <the-pagination
                        v-if="paging && paging.totalPages > 1"
                        class="mt-4"
                        :pagination="paging"
                        @change="onChange"
                    />
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import NotificationPreview from '@/components/notifications/NotificationPreview.vue'

export default {
    components: {
        NotificationPreview
    },
    methods: {
        onFiltersApply() {
            if (this.newsFetchTimeout) clearTimeout(this.newsFetchTimeout)
            this.newsFetchTimeout = setTimeout(() => {
                this.fetch()
            }, 100)
        },
        fetch() {
            return this.$store.dispatch('newsFetch')
        },
        onChange(page) {
            this.$router.push({ query: { ...this.$route.query, page: page } })
        }
    },
    computed: {
        filters() {
            return this.$store.getters.getNewsFilters
        },
        news() {
            return this.$store.getters.getNews
        },
        newsHeader() {
            return this.$store.getters.getNewsHeader
        },
        newsStatus() {
            return this.$store.getters.getNewsStatus
        },
        pagination() {
            return this.$store.getters.getNewsPagination
        },
        paging() {
            const p = this.pagination
            return {
                nextPage:
                    p.offset + p.count >= p.total
                        ? ''
                        : (p.count + p.offset) / p.limit + 1,
                page: Math.ceil((p.count + p.offset) / p.limit),
                perPage: p.limit,
                prevPage: p.offset === 0 ? '' : p.offset / p.limit,
                totalPages: Math.ceil(p.total / p.limit),
                totalRecords: p.total
            }
        },
        activeNews() {
            return this.$store.getters.getActiveNews
        }
    },
    created() {
        this.$nextTick(() => {
            if (this.newsHeader) {
                this.fetch().then(() => {
                    // fetch once again to update header news
                    this.$store
                        .dispatch('newsFetch', {
                            limit: 5,
                            offset: 0
                        })
                        .then(() => {
                            if (this.activeNews) {
                                this.$store.dispatch(
                                    'markOneNewsAsRead',
                                    this.activeNews
                                )
                            }
                        })
                })
            }
        })
    },
    mounted() {
        if (this.activeNews) {
            const el = document.querySelector(`#message-${this.activeNews}`)
            const headerHeight = document.querySelector('header').offsetHeight
            this.$scrollTo(el, 400, {
                offset: -headerHeight - 25
            })
        }
    },
    data() {
        return {
            newsFetchTimeout: null
        }
    }
}
</script>

<style lang="scss">
.message-header {
    svg {
        width: 100%;
    }
}
</style>
